import React from 'react';
import { connect } from 'react-redux';
import Unauthorized from './screens/components/basic/authorizedPage';

const PrivateRoute = (ComposedComponent, pageIndex) => {

  const isAuthorized = (id, accessList, isOwner) => {
    if (isOwner && accessList && accessList.access && accessList.access.length === 0) return true; // always grant access to ALL pages for Store Owner
    if (id === 15) return false;  // always deny acccss to User Role List page except Store Owner
    return accessList &&
      accessList.access &&
      accessList.access[id] &&
      accessList.access[id].hasAccess;
  };

  const PrivateRouteComponent = (props) => {
    const { userRolePage, authenticatedUser } = props;

    if (userRolePage === undefined || authenticatedUser === undefined) {
      return null;  // avoid rendering the Unauthorized component when page is refreshed 
    }

    const isOwner = authenticatedUser && authenticatedUser.roles.includes("StoreOwner") ? true : false;
    return isAuthorized(pageIndex, userRolePage, isOwner) ? (
      <ComposedComponent {...props} />
    ) : (
      <Unauthorized />
    );
  };

  const mapStateToProps = (state) => ({
    userRolePage: state.entity.userRolePage,
    authenticatedUser: state.common.authenticatedUser
  });

  return connect(mapStateToProps)(PrivateRouteComponent);
};

export default PrivateRoute;
